import React from 'react'
import i18n from 'i18next'

import Typography from '../../../UniformComponents/Typography'

const ContactDetails = () => (
    <div>
        <div className="pp-summary-slide-container">
            <img src="https://cdn.explori.com/images/logo_explori.png" alt="explori logo" style={{ width: 120, position: 'absolute', right: 50, top: 50 }} />

            <div className="pp-summary-slide-content" style={{ height: '100%', gap: 20 }}>
                <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
                    <Typography type="h2">{i18n.t('powerpoint.contactdetails.title')}</Typography>

                    <br />

                    <Typography type="b" color="primary">{i18n.t('powerpoint.contactdetails.who')}</Typography>

                    <br />

                    <Typography>{i18n.t('powerpoint.contactdetails.who.1')}</Typography>

                    <br />

                    <Typography>{i18n.t('powerpoint.contactdetails.who.2')}</Typography>

                    <br />

                    <Typography>{i18n.t('powerpoint.contactdetails.who.3')}</Typography>
                </div>

                <div style={{ padding: 20, backgroundColor: '#102E4A', borderRadius: 20, display: 'flex', width: '50%', flexShrink: 0, gap: 20 }}>
                    <i className="far fa-envelope-open" style={{ color: '#16CCC1', fontSize: 28 }} />

                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 20 }}>
                        <Typography type="b">{i18n.t('powerpoint.contactdetails.bubbletext.1')}</Typography>

                        <Typography>Customer Success: <Typography color="primary">support@explori.com</Typography></Typography>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

export default ContactDetails
